import React, { Component } from 'react';
// date time components
import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { zhCN } from 'date-fns/locale';
// Material components
import { InputAdornment,Chip, FormControl, InputLabel, Select, MenuItem, Typography, Divider, Grid, Box, IconButton, TextField, withStyles, Tooltip } from '@material-ui/core';

// Material icons
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
// Externals
import PropTypes from 'prop-types';
// Component styles
import styles from './styles';
// Form validation schema

const kqmode=[{id:0, name:'当天固定班次考勤', desp:'当天范围内，最多设置3个考勤时段，每个时段设置开始签到时间、上班考勤时间、下班考勤时间。多个时段之间的时间设置不能重叠。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间之后签到为迟到，下班考勤时间之前签退为早退。'},
    {id:1, name:'跨天固定班次考勤', desp:'24小时范围内，最多设置3个考勤时段，每个时段设置开始签到时间、上班考勤时间、下班考勤时间、结束签到时间，时段之间不能重叠，可以跨天设置时间，考勤时段的时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间之后签到为迟到，下班考勤时间之前签退为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'},
    {id:2, name:'固定班次弹性考勤', desp:'24小时范围内，最多设置1个弹性考勤时段，需设置开始签到时间、上班考勤时间、上班弹性延迟时长、下班考勤时间、结束签到时间，可以跨天设置时间，时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，上班考勤时间可以在上班弹性延迟时长范围内可以弹性延迟，超过上班弹性延迟时长范围签到为迟到，下班考勤时间根据上班考勤时间也会弹性延迟，在弹性延迟后的下班考勤时间之前签退为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'},
    {id:3, name:'固定班次自由考勤', desp:'24小时范围内，最多设置1个自由考勤时段，需设置开始签到时间、上班考勤时长、结束签到时间，可以跨天设置时间，时间跨度在24小时内。', desp2:'开始签到时间未到不能签到，到了开始签到时间可以签到，签到不设迟到，签退时如果工时未达到工作时长为早退，结束签到时间之前可以签退，结束签到时间之后不能签退'}
]

const hours=[{id:0, value:'00'}, {id:1, value:'01'}, {id:2, value:'02'}, {id:3, value:'03'}, {id:4, value:'04'}, {id:5, value:'05'}, {id:6, value:'06'}, {id:7, value:'07'}, {id:8, value:'08'}, {id:9, value:'09'}, {id:10, value:'10'}, {id:11, value:'11'}]

const minutes=[
    {id:0, value:'00'}, {id:1, value:'01'}, {id:2, value:'02'}, {id:3, value:'03'}, {id:4, value:'04'}, {id:5, value:'05'}, {id:6, value:'06'}, {id:7, value:'07'}, {id:8, value:'08'}, {id:9, value:'09'}, 
    {id:10, value:'10'}, {id:11, value:'11'}, {id:12, value:'12'}, {id:13, value:'13'}, {id:14, value:'14'}, {id:15, value:'15'}, {id:16, value:'16'}, {id:17, value:'17'}, {id:18, value:'18'}, {id:19, value:'19'}, 
    {id:20, value:'20'}, {id:21, value:'21'}, {id:22, value:'22'}, {id:23, value:'23'}, {id:24, value:'24'}, {id:25, value:'25'}, {id:26, value:'26'}, {id:27, value:'27'}, {id:28, value:'28'}, {id:29, value:'29'}, 
    {id:30, value:'30'}, {id:31, value:'31'}, {id:32, value:'32'}, {id:33, value:'33'}, {id:34, value:'34'}, {id:35, value:'35'}, {id:36, value:'36'}, {id:37, value:'37'}, {id:38, value:'38'}, {id:39, value:'39'}, 
    {id:40, value:'40'}, {id:41, value:'41'}, {id:42, value:'42'}, {id:43, value:'43'}, {id:44, value:'44'}, {id:45, value:'45'}, {id:46, value:'46'}, {id:47, value:'47'}, {id:48, value:'48'}, {id:49, value:'49'}, 
    {id:50, value:'50'}, {id:51, value:'51'}, {id:52, value:'52'}, {id:53, value:'53'}, {id:54, value:'54'}, {id:55, value:'55'}, {id:56, value:'56'}, {id:57, value:'57'}, {id:58, value:'58'}, {id:59, value:'59'}
]

const cross=['次日','当天']

class Index extends Component {
    handlePickerTime = e => {
    };
    handleCrossClick=(e)=>{
        e.stopPropagation()
    }
    handleCrossChange=(e,i)=>{
        e.stopPropagation()
        this.props.handlefieldchange(e.target.value,i)
    }

    handleNameClick=(e,i)=>{
        if(e.target.value.trim().length==0){
            this.props.isvalid(false)
        }
        this.props.handlefieldchange(e.target.value.trim(),i)
    }

    handleFieldChange=(v,i)=>{
        this.props.handlefieldchange(v,i)
    }

    render() {
        const { classes, form_value, changenum, accountinfo } = this.props; 

        return (
            <div style={{marginTop:5}}>
                <Typography component='div' variant="h6">
                    {kqmode[form_value.mode].name}
                    {(accountinfo.isVip<=0?<Typography component='span' variant="body2" style={{color:'red'}} >
                        （需要会员资格才能设置该考勤方式）
                    </Typography>:null)}
                </Typography>
                <Typography component='div' variant="body2" style={{marginTop:10}}>
                    设置要求：{kqmode[form_value.mode].desp}
                </Typography>
                {/* <Grid container spacing={4}>
                    <Grid item xs={2}>
                        <Typography component='span' variant="body1">
                            <TextField margin="dense" label="考勤方式" name="mode"  variant="outlined" required select
                                style={{width:'100%'}} value={form_value.mode} SelectProps={{ native: true }}
                                onChange={event => this.handleFieldChange(parseInt(event.target.value), 'mode') }
                            >
                                {kqmode.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </TextField>
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Box display='flex' alignItems="center" style={{width:'100%',height:'100%'}}>
                            <Tooltip title={kqmode[form_value.mode].desp2}>
                            <Typography component='span' variant='body2'>
                                {kqmode[form_value.mode].desp}
                            </Typography>
                            </Tooltip>
                        </Box>
                    </Grid>
                </Grid> */}
                <Divider style={{marginTop:10, marginBottom:10}} />
                <Grid container spacing={4}>
                    <Grid item xs={2} style={{display:'flex', alignItems:'center'}}>
                        <Typography component='div' variant="subtitle1" style={{color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                            自由考勤:
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Grid container>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='开始签到时间之前无法进行该时段的签到/签退，开始签到时间之后才可以该时段的签到/签退。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="考勤开始签到时间" cancelLabel="取消" okLabel="确定" inputVariant="outlined"
                                                margin="dense" ampm={false} style={{ marginRight: 20 }}
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode3info.stime1}
                                                onChange={value => this.handleFieldChange(value, 'stime1') }
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                                <FormControl size="small">
                                                                    <Select disabled={accountinfo.isVip>0?false:true}  style={{fontSize:14}} value={form_value.mode3info.flag11} autoWidth
                                                                        onChange={event=>this.handleCrossChange(event, 'flag11')}
                                                                        onClick={event=>this.handleCrossClick(event, 'flag11')}
                                                                    >
                                                                        <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                        <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <MuiPickersUtilsProvider locale={zhCN} utils={DateFnsUtils}>
                                    <Tooltip title='结束签到时间之前还可以该时段的签到/签退，结束签到时间之后无法再进行该时段的签到/签退。时间设置跨天时选择次日。'>
                                        <span>
                                            <TimePicker disabled={accountinfo.isVip>0?false:true} autoOk label="考勤结束签到时间" cancelLabel="取消"  okLabel="确定" inputVariant="outlined"
                                                ampm={false} margin="dense" style={{ marginRight: 20 }}
                                                InputLabelProps={{ classes: { root: classes.label } }} value={form_value.mode3info.etime1}
                                                onChange={value => this.handleFieldChange(value, 'etime1') }
                                                InputProps={{
                                                    startAdornment: 
                                                        <InputAdornment position="start">
                                                            {/* <Tooltip title='时间设置跨天时选择次日'> */}
                                                            <FormControl size="small">
                                                                <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode3info.flag14} autoWidth
                                                                    onChange={event=>this.handleCrossChange(event, 'flag14')}
                                                                    onClick={event=>this.handleCrossClick(event, 'flag14')}
                                                                >
                                                                    <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                                                    <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {/* </Tooltip> */}
                                                        </InputAdornment>,
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} style={{display:'flex', alignItems:'center'}}>
                                <Tooltip title='签到考勤期间累计工作时长小于所要求工作时长的话为早退。'><span>
                                    <Typography component='span' variant="subtitle2" style={{marginRight:5,color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                                        考勤期间的工作时长要求：
                                    </Typography>
                                    <FormControl size="small">
                                        <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode3info.wthour1} autoWidth
                                            onChange={event=>this.handleCrossChange(event, 'wthour1')}
                                            onClick={event=>this.handleCrossClick(event, 'wthour1')}
                                        >
                                            {hours.map(option => (
                                                <MenuItem value={option.id}><span style={{fontSize:14}}>{option.value}</span></MenuItem>
                                            ))}
                                            {/* <MenuItem value={1}><span style={{fontSize:14}}>当天</span></MenuItem>
                                            <MenuItem value={0}><span style={{fontSize:14, color:'blue'}}>次日</span></MenuItem> */}
                                        </Select>
                                    </FormControl>
                                    <Typography component='span' variant="subtitle2" style={{marginRight:20,color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                                        小时
                                    </Typography>
                                    <FormControl size="small">
                                        <Select disabled={accountinfo.isVip>0?false:true} style={{fontSize:14}} value={form_value.mode3info.wtminute1} autoWidth
                                            onChange={event=>this.handleCrossChange(event, 'wtminute1')}
                                            onClick={event=>this.handleCrossClick(event, 'wtminute1')}
                                        >
                                            {minutes.map(option => (
                                                <MenuItem value={option.id}><span style={{fontSize:14}}>{option.value}</span></MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Typography component='span' variant="subtitle2" style={{marginRight:20,color:accountinfo.isVip>0?'#12161b':'#aaaaaa'}} >
                                        分钟
                                    </Typography></span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Divider style={{marginTop:5, marginBottom:10}} />                
                <Typography component='div' variant="body2" style={{marginTop:10}}>
                    注意事项：{kqmode[form_value.mode].desp2}
                </Typography> */}

                
            </div>
        );
    }
}
Index.propTypes = {
    changenum: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    form_value: PropTypes.object.isRequired,
    handlefieldchange: PropTypes.func.isRequired,
    accountinfo: PropTypes.object.isRequired
    // num: PropTypes.number.isRequired,
    // isvalid: PropTypes.func.isRequired
};
export default withStyles(styles)(Index);
